import { useAppContext } from "@src/autoDebit/AppContext";
import message from "@src/autoDebit/message";
import styles from "./index.module.css";

const Final = () => {
  const { intl } = useAppContext();
  return (
    <div className={styles.wrap}>
      {intl.formatMessage(message.FinalExplanation)}
    </div>
  );
};

export default Final;
